import styled from 'styled-components';
import { Text, FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
  border: ${({ theme: { system } }) =>
    `${system.fds_sys_borderwidth_S} solid ${system.border.fds_sys_color_border_primary}`};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  width: 300px;
  position: relative;
  padding: ${({ theme: { reference } }) => reference.dimension_08};
  margin: ${({ theme: { reference } }) => reference.dimension_16};
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
  height: fit-content;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    width: auto;
    padding: ${({ theme: { reference } }) => reference.dimension_24};
    margin: ${({ theme: { reference } }) => reference.dimension_08};
  }
`;

export const HeaderContainer = styled(FlexContainer)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  padding: ${pxToRem(16)};
  cursor: pointer;
`;

export const BenefitsContainer = styled(FlexContainer)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${pxToRem(16)};
  height: 100%;
`;

export const TextContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-left: ${pxToRem(25)};
  margin-right: ${pxToRem(25)};
  svg {
    width: auto;
    height: ${pxToRem(20)};
    position: initial;
  }
`;

export const AmountContent = styled.section`
  display: flex;
  align-items: center;
`;

export const ItemContainer = styled.ul`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const ItemList = styled.li`
  display: flex;
  align-items: center;
  padding: 0px;
  width: 100%;
  height: ${pxToRem(20)};
  margin-bottom: ${pxToRem(15)};
`;

export const ItemIcon = styled.div`
  display: flex;
  padding: ${pxToRem(10)};
`;

export const ListContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SpinnerContainer = styled(FlexContainer)`
  height: 100%;
`;

export const Recommended = styled.div<{ isRecommended: boolean }>`
  visibility: ${({ isRecommended }) => (isRecommended ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: ${({ theme: { system } }) =>
    system.background.fds_sys_color_background_primary_inverse};
  padding: ${({ theme: { reference } }) => `${reference.dimension_04} 0`};
  border-radius: ${({ theme: { system } }) =>
    `${system.fds_sys_borderradius_L} ${system.fds_sys_borderradius_L} 0 0`};
`;

export const Price = styled.span`
  ${({ theme: { components } }) => components.plans.fds_c_price_typo_S_extended};
`;
export const Description = styled(Text)`
  display: none;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    display: flex;
  }
`;
